export enum GeometryType {
  Point = 'Point',
  Line = 'Line',
  Box = 'Box',
  Path = 'Path',
  Polygon = 'Polygon',
  Circle = 'Circle',
}

export interface LngLat {
  lng: number
  lat: number
}

export enum ProjectionEnum {
  worldGeodeticSystem1984 = 'EPSG:4326',
  webMercator = 'EPSG:3857',
}

export class Geography {
  public type: GeometryType
  public coordinates: [number, number, number]

  constructor(type: GeometryType, coordinates: [number, number, number]) {
    this.type = type
    this.coordinates = coordinates
  }
}
